export const aciCruises = {
    iconName: 'cruises',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 22 24' },
        path: [
            {
                attr: {
                    d: 'M16.564 13.783c-.409 0-.682-.273-.682-.682V7.915A2.156 2.156 0 0013.7 5.732H7.83a2.156 2.156 0 00-2.183 2.183v5.186c0 .41-.273.682-.682.682-.41 0-.683-.273-.683-.682V7.915c0-2.047 1.638-3.548 3.548-3.548H13.7c2.047 0 3.548 1.638 3.548 3.548v5.186c0 .41-.273.682-.683.682z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M20.931 15.557h-.273L11.105 11.6h-.546L.87 15.42c-.41.136-.682 0-.819-.41-.136-.409 0-.682.41-.818l9.689-3.821a1.74 1.74 0 011.638 0l9.689 3.82c.41.137.546.547.41.82-.41.41-.683.545-.956.545z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M4.009 19.379a.75.75 0 01-.683-.41l-1.5-4.64c-.137-.41 0-.682.409-.819.409-.136.682.137.818.41l1.502 4.64c.136.41-.137.682-.41.819H4.01zM10.832 18.833c-.41 0-.682-.273-.682-.683v-7.232c0-.41.273-.683.682-.683.41 0 .683.273.683.683v7.232c0 .41-.41.683-.683.683zM17.52 19.651h-.274c-.41-.136-.546-.545-.41-.818l1.639-4.777c.136-.41.545-.546.818-.41.41.137.546.547.41.82l-1.502 4.64c-.136.273-.409.545-.682.545z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M18.202 17.741h-.273l-7.097-3.002L3.6 17.605c-.409.136-.682 0-.818-.41-.137-.41 0-.682.41-.819l7.368-3.002h.546l7.37 3.002c.41.137.546.546.41.82-.137.272-.41.545-.683.545zM14.107 23.336c-1.228 0-2.32-.41-3.275-1.228-1.774 1.501-4.776 1.501-6.55 0-.546.41-1.092.682-1.638.955-.41.137-.682 0-.819-.409-.136-.41 0-.682.41-.819.682-.273 1.228-.546 1.637-1.092 0-.272.137-.272.41-.272.136 0 .409.136.545.272 1.365 1.502 4.095 1.502 5.596 0 0-.136.136-.272.41-.272.136 0 .409.136.545.272 1.365 1.502 4.094 1.502 5.595 0 .137-.136.273-.272.546-.272.137 0 .41 0 .546.136.546.41 1.092.819 1.638 1.092.409.136.546.546.409.818-.136.41-.546.546-.819.41-.546-.273-1.228-.546-1.637-.955-1.229.818-2.32 1.364-3.549 1.364zM13.698 8.598H7.83c-.41 0-.683-.273-.683-.683 0-.41.273-.682.683-.682h5.868c.41 0 .682.273.682.682 0 .41-.273.683-.682.683zM12.197 5.732H9.33c-.41 0-.683-.273-.683-.683V1.365C8.648.545 9.331 0 10.013 0h1.501c.82 0 1.365.682 1.365 1.365v3.684c0 .41-.273.683-.682.683zm-2.184-1.365h1.501V1.365h-1.5v3.002z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
